import { useParams } from 'react-router';
import { SubjectDetail } from '../../subjects/components/SubjectDetail';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { ManagerMenu } from '../../manager/managermenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
const ManagerSubjectDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { manager, apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.manager && manager?.modules?.subjects ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
          resource='Subjects'
          action='list.view'
        >
          <SubjectDetail subjectId={id!} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default ManagerSubjectDetailPage;
